goog.provide("shadow.js.shim.module$src$svg$artwork$no_access_svg$default");
shadow.js.shim.module$src$svg$artwork$no_access_svg$default = shadow.js.shim.module$src$svg$artwork$no_access_svg.default;
